<template>
  <v-sheet
    ref="sheet"
    :height="height"
    class="overflow-y-auto"
  >
    <progress-page v-if="chatsState.loading"/>
    <div v-if="chatsState.success && chatsState.data.count===0">
      <alert>Не найдено</alert>
    </div>
    <v-list v-if="chatsState.success && chatsState.data.count>0" dense class="pa-0">
      <v-list-item
          v-for="item in chatsState.data.items" :key="item.id"
          @click="localChat=item"
          class="pa-0"
          :class="$tools.isEmpty(localChat) ? '' : localChat.id===item.id ? 'v-list-item--active' : ''"
      >
        <v-row no-gutters class="full-width">
          <v-col class="pa-3">
            <v-row no-gutters>
              <v-col>{{item.info.userClient.name}}</v-col>
              <v-col cols="auto">
                <chat-priority :chat="item" :type="type"/>
              </v-col>
            </v-row>
            <v-row no-gutters align="center">
              <v-col style="flex:1" class="body-2 text-no-wrap overflow-hidden text-overflow muted1">
                <span v-if="item.info.messageLast===null" class="body-2 text-no-wrap overflow-hidden muted">
                  Нет сообщений
                </span>
                <span v-else>
                  <span v-if="item.info.messageLast.info.user.userType!=='client'">Сотрудник: </span>
                  <span style="flex:1">{{item.info.messageLast.text}}</span>
                  <span v-if="item.info.messageLast.mediaPath!==null">(Вложение)</span>
                </span>
              </v-col>
              <v-col cols="auto" class="pl-2">
                <v-sheet v-if="item.info.unreadCount>0" width="20" height="20" color="transparent">
                  <v-avatar size="20" color="primary" class="caption white--text position-absolute">
                    {{item.info.unreadCount}}
                  </v-avatar>
                </v-sheet>
              </v-col>
            </v-row>
            <chip v-if="filterView?.id==='all' && !$tools.isEmpty(item.userOperator)" class="mt-1" small>Оператор: {{$tools.userFullName(item.userOperator, true)}}</chip>
          </v-col>
          <v-col cols="12">
            <v-divider/>
          </v-col>
        </v-row>
      </v-list-item>
    </v-list>
    <progress-page v-if="page>1 && chatsState.data.count>chatsState.data.items.length"/>
    <audio ref="ring">
      <source src="../../../../assets/ring.mp3" type="audio/mpeg">
    </audio>
  </v-sheet>
</template>

<script>
import Stater from "../../../../plugins/stater";
import ProgressPage from "../../../../components/ProgressPage.vue";
import {Entity_Chat, Entity_Message, Entity_User, Entity_UserProfile} from "../../../../../EntityStoreCacheService";
import ChatPriority from "@/views/ContactCenter/Messenger/components/ChatPriority.vue";
import Alert from "@/componentsV2/base/Alert.vue";
import Chip from "@/componentsV2/base/Chip.vue";

export default {
  components: {Chip, Alert, ChatPriority, ProgressPage},
  props: ['height','type','chat','search','filterView','filterSort'],
  data: () => ({
    chatsState: new Stater({items:[],count:0}),
    chatsMoreState: new Stater(),
    subscribeListenerId:null,
    localChat:null,
    page:1,
  }),
  mounted() {
    this.localChat = this.chat;
    this.load();
    this.$ws.connectWithSubscribeListener(this.$store.state.user, (v)=>this.subscribeListenerId=v, (m)=>{
      if((m.type==='messengerMessage' || m.type==='messengerMessageReaded') && m.data.chat.type === this.type)
        this.load(false)
      if(m.type==='messengerMessage' && m.data.chat.type === this.type && m.data.info.user.userId!==this.$store.state.user?.id)
        this.$refs.ring.play();

      if(m.type==='messengerChatsUpdate')
        this.load()
    });
    this.$refs.sheet.$el.addEventListener('scroll',this.scrollHandler);
  },
  watch:{
    chat(){this.localChat = this.chat;},
    localChat(){this.$emit('update:chat', this.localChat)},
    type(){this.load();},
    filterView(){this.load();},
    filterSort(){this.load();},
    search(){this.load();},
  },
  beforeDestroy() {
    this.$ws.removeSubscribeListener(this.subscribeListenerId);
    this.$refs.sheet.$el.removeEventListener('scroll',this.scrollHandler);
  },
  methods:{
    load(fast=true, page=1){
      if(this.chatsState.data.count===0 || !this.$tools.isEmpty(this.search)){
        this.chatsState.stateLoading();
        this.$emit('state', this.chatsState);
      }
      this.$tools.debounce(()=>{
        let rb = new Entity_Chat()
            .selects(Entity_Chat.id)
            .selects(Entity_Chat.type)
            .selects(Entity_Chat.closed)
            .selects([Entity_Chat.userOperator, Entity_User.id].join('.'))
            .selects([Entity_Chat.userOperator, Entity_User.firstName].join('.'))
            .selects([Entity_Chat.userOperator, Entity_User.lastName].join('.'))
            .selects([Entity_Chat.userOperator, Entity_User.secondName].join('.'))
            .selects([Entity_Chat.userOperator, Entity_User.type].join('.'))
            .selects([Entity_Chat.userOperator, Entity_User.userProfile, Entity_UserProfile.gender].join('.'))
            .selects([Entity_Chat.userOperator, Entity_User.userProfile, Entity_UserProfile.birth].join('.'))
            .virtual(Entity_Chat.virtual_info)
            .filterAnd([Entity_Chat.entity, Entity_Chat.type].join('.')+'=?',this.type);

        if(this.filterView.id==='my' && this.type!=='queue' && this.type!=='closed')
          rb.filterAnd([Entity_Chat.entity, Entity_Chat.userOperator, Entity_User.id].join('.')+'=?',this.$store.state.user?.id);

        if(!this.$tools.isEmpty(this.search)){
          let qarr = [];

          let phones = this.$tools.phonesSearch(this.search);
          if(phones!==null && phones.length>0){
            phones.forEach((phone)=>{
              phone = this.$tools.phoneFormat(phone, true, true)
              qarr.push([Entity_Chat.entity, Entity_Chat.userClient, Entity_User.phone].join('.') + ' LIKE ?');
              qarr.push([Entity_Chat.entity, Entity_Chat.userClient, Entity_User.userProfile, Entity_UserProfile.phone1].join('.') + ' LIKE ?');
              qarr.push([Entity_Chat.entity, Entity_Chat.messages, Entity_Message.contactPhone].join('.') + ' LIKE ?');
              rb._filterParams.push(phone)
              rb._filterParams.push(phone)
              rb._filterParams.push(phone)
            })
          } else {
            qarr.push([Entity_Chat.entity, Entity_Chat.messages, Entity_Message.text].join('.')+' LIKE ?');
            rb._filterParams.push('%' + this.search + '%')

            qarr.push([Entity_Chat.entity, Entity_Chat.messages, Entity_Message.contactName].join('.')+' LIKE ?');
            rb._filterParams.push('%' + this.search + '%')

            let arr = this.search.split(' ');
            if (arr.length === 1 && arr[0][0]==='(') {//Для старой фамилии в скобках
              qarr.push([Entity_Chat.entity, Entity_Chat.userClient, Entity_User.lastName].join('.') + ' LIKE ?')
              rb._filterParams.push('%' + arr[0] + '%')
            } else if (arr.length === 1) {
              qarr.push([Entity_Chat.entity, Entity_Chat.userClient, Entity_User.lastName].join('.') + ' LIKE ?')
              rb._filterParams.push(arr[0] + '%')
            } else if (arr.length === 2) {
              qarr.push(
                  [Entity_Chat.entity, Entity_Chat.userClient, Entity_User.lastName].join('.') + ' = ? AND '+
                  [Entity_Chat.entity, Entity_Chat.userClient, Entity_User.firstName].join('.') + ' LIKE ?'
              );
              rb._filterParams.push(arr[0])
              rb._filterParams.push(arr[1] + '%')
            } else if (arr.length === 3) {
              qarr.push(
                  [Entity_Chat.entity, Entity_Chat.userClient, Entity_User.lastName].join('.') + ' = ? AND '+
                  [Entity_Chat.entity, Entity_Chat.userClient, Entity_User.firstName].join('.') + ' = ? AND '+
                  [Entity_Chat.entity, Entity_Chat.userClient, Entity_User.secondName].join('.') + ' LIKE ?'
              );
              rb._filterParams.push(arr[0])
              rb._filterParams.push(arr[1])
              rb._filterParams.push(arr[2] + '%')
            }
          }

          rb.filterAnd(qarr.join(' OR '));
        }

        if(this.$tools.isDefined(this.filterSort)){
          if(this.filterSort.id==='priority')
            rb.order([Entity_Chat.messageLast, Entity_Message.id].join('.'), true);
          else if(this.filterSort.id==='time')
            rb.order([Entity_Chat.messageLast, Entity_Message.id].join('.'), false);
        }


        rb
            .page(page)
            .onPage(20)
            .addStateCallback((v)=>{
              if(v.success) {
                /*
                this.$emit('count', v.items.length)

                let unreadCount = 0;
                v.items.forEach(v1=>{
                  unreadCount += parseInt(v1.info.unreadCount);
                })
                this.$emit('unreadCount', unreadCount)

                 */


                v.items
                    .filter(v=>v.id===this.localChat?.id)
                    .filter(v=>!this.$tools.equals(v.info.userClient, this.localChat.info.userClient))
                    .forEach(v1=>{
                      this.localChat = v1;
                    })


              }
              if(!v.loading){
                this.chatsState.setRequestBuilderState(v, true, page>1)
                this.$emit('state', this.chatsState);
              }
            })
            .request()
      }, fast ? 100 : 2000, 'chatsLoad_'+this.type)
    },
    scrollHandler(){
      const el = this.$refs.sheet.$el;
      if(el.scrollTop + el.clientHeight >= el.scrollHeight-100 && this.chatsState.data.count>this.chatsState.data.items.length){
        this.$tools.debounce(()=>{
          this.load(true, ++this.page);
        }, 500, 'scrollHandler_'+this.type)
      }
    }
  }
}
</script>